/**
 * Horse data for the horse pictures swipe app
 * Images are self-hosted (processed by scripts/process-images.sh)
 */

export const horses = [
  {
    id: 1,
    name: 'Thunder',
    breed: 'Arabian',
    age: 7,
    color: 'Bay',
    image: '/images/thunder/profile.jpg',
    video: '/videos/thunder/profile.mp4',
    bg: 'linear-gradient(135deg, #2d1b0e, #4a2c17)',
    bio: 'A spirited Arabian with incredible endurance and a gentle soul.',
    location: 'Kentucky, USA',
  },
  {
    id: 2,
    name: 'Misty',
    breed: 'Appaloosa',
    age: 5,
    color: 'Spotted',
    image: '/images/misty/profile.jpg',
    video: '/videos/misty/profile.mp4',
    bg: 'linear-gradient(135deg, #1a3a4a, #0d2030)',
    bio: 'Beautiful spotted coat with a playful personality. Loves apples!',
    location: 'Montana, USA',
  },
  {
    id: 3,
    name: 'Shadow',
    breed: 'Friesian',
    age: 9,
    color: 'Black',
    image: '/images/shadow/profile.jpg',
    video: '/videos/shadow/profile.mp4',
    bg: 'linear-gradient(135deg, #1a1a2e, #0f0f1a)',
    bio: 'Majestic Friesian with flowing mane. Excellent for dressage.',
    location: 'Netherlands',
  },
  {
    id: 4,
    name: 'Buttercup',
    breed: 'Palomino',
    age: 4,
    color: 'Golden',
    image: '/images/buttercup/profile.jpg',
    video: '/videos/buttercup/profile.mp4',
    bg: 'linear-gradient(135deg, #4a3f20, #2d2510)',
    bio: 'Golden beauty with a calm temperament. Perfect for trail rides.',
    location: 'Texas, USA',
  },
  {
    id: 5,
    name: 'Storm',
    breed: 'Mustang',
    age: 6,
    color: 'Dun',
    image: '/images/storm/profile.jpg',
    video: '/videos/storm/profile.mp4',
    bg: 'linear-gradient(135deg, #3d2e1f, #261c12)',
    bio: 'Wild spirit with incredible stamina. Recently gentled.',
    location: 'Nevada, USA',
  },
  {
    id: 6,
    name: 'Snowflake',
    breed: 'Lipizzan',
    age: 8,
    color: 'White',
    image: '/images/snowflake/profile.jpg',
    video: '/videos/snowflake/profile.mp4',
    bg: 'linear-gradient(135deg, #3a3a4a, #1f1f2f)',
    bio: 'Classical dressage trained. Graceful and intelligent.',
    location: 'Vienna, Austria',
  },
  {
    id: 7,
    name: 'Copper',
    breed: 'Quarter Horse',
    age: 5,
    color: 'Chestnut',
    image: '/images/copper/profile.jpg',
    video: '/videos/copper/profile.mp4',
    bg: 'linear-gradient(135deg, #5c3d2e, #3a251c)',
    bio: 'Athletic and versatile. Great for ranch work and rodeo.',
    location: 'Wyoming, USA',
  },
  {
    id: 8,
    name: 'Luna',
    breed: 'Andalusian',
    age: 6,
    color: 'Gray',
    image: '/images/luna/profile.jpg',
    video: '/videos/luna/profile.mp4',
    bg: 'linear-gradient(135deg, #2a2a3a, #151520)',
    bio: 'Elegant Spanish beauty. Exceptional movement and presence.',
    location: 'Andalusia, Spain',
  },
  {
    id: 9,
    name: 'Duke',
    breed: 'Clydesdale',
    age: 10,
    color: 'Bay with white',
    image: '/images/duke/profile.jpg',
    video: '/videos/duke/profile.mp4',
    bg: 'linear-gradient(135deg, #3d2a1a, #261a10)',
    bio: 'Gentle giant with feathered feet. Great with children.',
    location: 'Scotland',
  },
  {
    id: 10,
    name: 'Willow',
    breed: 'Paint Horse',
    age: 4,
    color: 'Pinto',
    image: '/images/willow/profile.jpg',
    video: '/videos/willow/profile.mp4',
    bg: 'linear-gradient(135deg, #2e3d2a, #1a251a)',
    bio: 'Colorful and friendly. Loves attention and treats.',
    location: 'Oklahoma, USA',
  },
];
